import {
  LS_KEY_ACTIVE_SLIDES_FRAME_BY_JOB,
  LS_KEY_ACTIVE_SLIDES_JOB_IDS,
  LS_KEY_CONTENT_READY_MODE,
  type ContentReadyMode,
} from "@/utils/slides/slidesTaskpaneContract";

export function getContentReadyMode(): ContentReadyMode {
  return localStorage.getItem(LS_KEY_CONTENT_READY_MODE) === "slides" ? "slides" : "charts";
}

export function setContentReadyMode(mode: ContentReadyMode): void {
  localStorage.setItem(LS_KEY_CONTENT_READY_MODE, mode);
}

export function readActiveJobIds(): string[] {
  const raw = localStorage.getItem(LS_KEY_ACTIVE_SLIDES_JOB_IDS);
  if (!raw) return [];
  const parsed = JSON.parse(raw);
  return Array.isArray(parsed) ? parsed : [];
}

export function readFrameByJob(): Record<string, number> {
  const raw = localStorage.getItem(LS_KEY_ACTIVE_SLIDES_FRAME_BY_JOB);
  if (!raw) return {};
  return JSON.parse(raw) as Record<string, number>;
}

export function addActiveSlidesJob(jobId: string, slideFrameId?: number): void {
  const ids = readActiveJobIds();
  if (!ids.includes(jobId)) {
    ids.push(jobId);
    localStorage.setItem(LS_KEY_ACTIVE_SLIDES_JOB_IDS, JSON.stringify(ids));
  }
  if (slideFrameId !== undefined) {
    const map = readFrameByJob();
    map[jobId] = slideFrameId;
    localStorage.setItem(LS_KEY_ACTIVE_SLIDES_FRAME_BY_JOB, JSON.stringify(map));
  }
}

export function removeActiveSlidesJob(jobId: string): void {
  const ids = readActiveJobIds().filter((id) => id !== jobId);
  localStorage.setItem(LS_KEY_ACTIVE_SLIDES_JOB_IDS, JSON.stringify(ids));
  const map = readFrameByJob();
  if (jobId in map) {
    delete map[jobId];
    localStorage.setItem(LS_KEY_ACTIVE_SLIDES_FRAME_BY_JOB, JSON.stringify(map));
  }
  notifySlidesJobsChanged();
}

// Broadcast to in-window listeners (App, SlidesContentReady) that the job set changed.
export function notifySlidesJobsChanged(): void {
  window.postMessage({ type: "SLIDES_JOBS_CHANGED" }, "*");
}

export function notifySlidesContentReady(jobId: string | undefined): void {
  window.postMessage({ type: "SLIDES_CONTENT_READY", jobId }, "*");
}
